<template>
  <div class="home-wrap">
    <div class="layout-header-wrap">
      <HeaderOperation></HeaderOperation>
    </div>
    <div class="layout-body-wrap">
      <div class="body-wrap">
        <SideMenu @handleClick="handleClick" v-if="!isShow"></SideMenu>
        <Code v-if="!isShow"></Code>
        <router-view></router-view>
      </div>
      <FooterInfo></FooterInfo>
    </div>
  </div>
</template>

<script>
const ythPath = process.env.VUE_APP_BASE_YTH
import {path} from './routerPath'
import {getBpmToken} from '@/api/back.js'
import {getTenantId} from '@/api/databaseBin.js'
import { getStorage, setStorage } from "@/utils/index";
import HeaderOperation from './components/HeaderOperation/index.vue'
import FooterInfo from '@/components/FooterInfo/index'
import SideMenu from './components/SideMenu/index'
import Code from './components/code'
import { mapState } from 'vuex'
export default {
  data() {
    return {}
  },
  components: {
    HeaderOperation,
    FooterInfo,
    SideMenu,
    Code
  },
  computed: {
    isShow(){
      return path.includes(this.$route.path)
    },
    ...mapState({
      token: state => state.user.token
    })
  },
  methods: {
    // 处理导航菜单的跳转
    async handleClick(val) {
      let res, tk
      switch (val) {
        case '华师专利库':
          window.open(
            'https://scnu.ipsunlight.com/fvue/home'
          )
          break
        case '二级机构':
          if (!this.token) {
            this.$message.warning('请先登录')
            return
          }
          tk = await getTenantId()
          window.open(`${ythPath}?username=${getStorage('userName', 0)}&huashi=1&tenantId=${tk.id}`)
          break
        case '重点实验室':
          if (!this.token) {
            this.$message.warning('请先登录')
            return
          }
          tk = await getTenantId()
          window.open(`${ythPath}?username=${getStorage('userName', 0)}&huashi=2&tenantId=${tk.id}`)
          break
        case '华师知识产权资源平台':
          if (!this.token) {
            window.open('https://scnu.ipsunlight.com/fvue/home')
          } else {
            tk = await getTenantId()
            window.open(`${ythPath}?username=${getStorage('userName', 0)}&huashi=true&tenantId=${tk.id}`)
          }
          break
        case '本校专利图谱':
          if (!this.token) {
            this.$message.warning('请先登录')
            return
          }
          res = await getBpmToken()
          setStorage("bpmToken", res.token, 0)
          window.open('https://ipisc.scnu.edu.cn/#/patentAtlas')
          break
        case '渔业专题库':
          window.open('http://www.innojoy.com/account/login2.html?idEMail=hnsfyk@139.com&idPassword=joy220617&url=special/progress.htm?ProjectID=2426')
          // this.$message.warning("功能开发中，敬请期待");
          break
        case '云计算专题库':
          window.open('http://www.innojoy.com/account/login2.html?idEMail=hnsfyk@139.com&idPassword=joy220617&url=special/progress.htm?ProjectID=2426')
          // this.$message.warning("功能开发中，敬请期待");
          break
        default:
          console.log(val)
          break
      }
    },
    
  }
}
</script>

<style></style>
